"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var FormField_1 = require("../FormField");
var FormGroup_1 = require("../FormGroup");
var FormControls_1 = require("../FormControls");
var Form = function (_a) {
    var action = _a.action, children = _a.children, className = _a.className, _b = _a.el, Element = _b === void 0 ? 'form' : _b, onSubmit = _a.onSubmit, _c = _a.size, size = _c === void 0 ? 'medium' : _c, props = __rest(_a, ["action", "children", "className", "el", "onSubmit", "size"]);
    var handleSubmit = function (e) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // Third party libs can pass own data as first argument, we need to check that it has preventDefault() method.
        if (typeof action !== 'string') {
            e.preventDefault();
        }
        if (onSubmit) {
            onSubmit(e, __assign(__assign({}, props), args));
        }
        // _.invoke(this.props, 'onSubmit', e, this.props, ...args)
    };
    var FormClasses = classnames_1.default('Form', className, "Form--" + size);
    return (react_1.default.createElement(Element, __assign({}, props, { className: FormClasses, onSubmit: handleSubmit }), children));
};
exports.Form = Form;
exports.Form.Checkbox = FormControls_1.FormCheckbox;
exports.Form.Radio = FormControls_1.FormRadio;
exports.Form.TextArea = FormControls_1.FormTextArea;
exports.Form.Button = FormControls_1.FormButton;
exports.Form.ButtonToggle = FormControls_1.FormButtonToggle;
exports.Form.ColorPicker = FormControls_1.FormColorPicker;
exports.Form.DatePicker = FormControls_1.FormDatePicker;
exports.Form.DateRangePicker = FormControls_1.FormDateRangePicker;
exports.Form.Dropdown = FormControls_1.FormDropdown;
exports.Form.Field = FormField_1.FormField;
exports.Form.Group = FormGroup_1.FormGroup;
exports.Form.Input = FormControls_1.FormInput;
exports.Form.Select = FormControls_1.FormSelect;
exports.Form.Togglebox = FormControls_1.FormTogglebox;
exports.Form.ToggleSwitch = FormControls_1.FormToggleSwitch;
exports.Form.AnvilSelect = FormControls_1.FormAnvilSelect;
//# sourceMappingURL=Form.js.map